import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
import AlertContext from "../../Context/Alert/AlertContext";
import { BaseURL } from "../../Files/BaseURL";
import axios from "axios";
import ThemeContext from "../../Context/theme/ThemeContext";
function EditSkill({ SkillModel, setSkillModel, fetchUser }) {
  const { id } = useParams();
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const [ServiceSelect, setServiceSelect] = useState(null);
  const [ServiceSkill, setServiceSkill] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillData, setSkillData] = useState("");
  const[loading,setLoading]=useState();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const authToken = localStorage.getItem("p@token");
        const response = await axios.get(`${BaseURL}/api/user/userSkill`, {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        });

        if (response.data) {
          setSkills(response.data.Skills);
          setServiceSelect(response.data.Industry);
        } else {
          showAlert("No pending documents found", "info");
        }
      } catch (error) {
        showAlert("Error fetching pending documents", "danger");
      }
    };

    fetchServices();
  }, [showAlert]);

  useEffect(() => {
    const fetchServiceSkills = async () => {
      if (ServiceSelect) {
        try {
          const authToken = localStorage.getItem("p@token");
          const response = await fetch(
            `${BaseURL}/api/auth/servicecategoryDetail/${ServiceSelect}`,
            {
              headers: {
                "auth-token": authToken,
              },
            }
          );
          const data = await response.json();
          const subSkills = data.Skills.flatMap((skill) => skill.subSkill);
          setServiceSkill(subSkills);
        } catch (error) {
          showAlert("Error fetching Services", "danger");
        }
      }
    };

    fetchServiceSkills();
  }, [ServiceSelect, showAlert]);

  const handleSkillChange = (e) => {
    const selectedSkillId = e.target.value;
    if (skills.some((skill) => skill._id === selectedSkillId)) {
      return;
    } else {
      const selectedSkill = ServiceSkill.find(
        (skill) => skill._id === selectedSkillId
      );
      if (selectedSkill) {
        setSkills((prevSkills) => [...prevSkills, selectedSkill]);
        setSkillData("");
      }
    }
  };

  const handleRemoveSkill = (skillId) => {
    setSkills((prevSkills) =>
      prevSkills.filter((skill) => skill._id !== skillId)
    );
  };

  const handleUpdateSkills = async () => {
    
    setLoading(true);
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.put(
        `${BaseURL}/api/user/updateSkils`,
        { skillsData: skills },
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        showAlert("Skills updated successfully", "success");
        setSkillModel(false);
        fetchUser();
        setLoading(false);
      } else {
        showAlert(response.data.message, "danger");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      showAlert("Error updating skills", "danger");
      setLoading(false);
    }
  };

  return (
    <>
      {SkillModel && (
        <div className="fixed top-0 left-0 w-screen h-screen z-40 flex justify-center items-center">
          <div
            className="absolute bg-black/50 w-screen h-screen z-30"
            onClick={() => {
              setSkillModel(false);
            }}
          ></div>
          <div
            className={`px-6 mx-auto w-[95%] md:w-[60%] lg:w-[40%] relative mt-10 z-40  p-8 rounded-lg shadow-md
                        ${
                          theme == "dark" ? "bg-black text-white" : " bg-white"
                        }`}
          >
            <p
              className={` text-gray-600 font-pop mb-2 text-lg max-w-sm ${
                theme == "dark" && "text-white"
              }`}
            >
              Choose skills most suitable for you:
            </p>
            <div className="mb-4">
              <select
                name="skill"
                id="skill"
                value={skillData}
                onChange={handleSkillChange}
                className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none ${
                  theme == "dark" ? "bg-black text-white border border-white" : " bg-white"
                }`}
              >
                <option value="">Skills</option>
                {ServiceSkill.map((item, index) => (
                  <option value={item._id} key={index}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-4 grid md:grid-cols-2 grid-cols-1 gap-2">
              {skills.map((item, index) => (
                <div
                  className="bg-primarygreen/50 items-center text-base font-pop rounded-2xl py-2 px-6 flex justify-between"
                  key={index}
                >
                  <p>{item.name}</p>
                  <RxCrossCircled onClick={() => handleRemoveSkill(item._id)} />
                </div>
              ))}
            </div>

            <button
              onClick={handleUpdateSkills}
              className={`my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp
              ${theme==="dark"?"hover:text-white":"hover:text-black"}`}
            >
             {loading?"updating...":"Update Skills"} 
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default EditSkill;
